<template>
  <div class="users">
    <md-progress-bar md-mode="indeterminate" v-if="loading" />
    <ModalSystemUsers
      v-if="ModalUsersActive"
      @closeModal="ModalUsersActive = false"
    ></ModalSystemUsers>
    <ModalSystemUsers
      v-if="ModalUsersActiveUpdate"
      :user="selectedUser"
      @closeModal="ModalUsersActiveUpdate = false"
    ></ModalSystemUsers>

    <div class="users__header">
      <div class="users__first">Usuarios de Sistema</div>
      <div class="users__add">
        <button class="button-add" @click="ModalUsersActive = true">
          Agregar Usuario
        </button>
      </div>
      <md-field class="business-field">
        <label for="business">Empresas</label>
        <md-select v-model="actualBusiness" name="business" id="business">
          <md-option
            :value="business.id"
            v-for="business in businessList"
            :key="business.id"
            >{{ business.name }}</md-option
          >
        </md-select>
      </md-field>
    </div>

    <div class="users__body" v-if="!!users.length">
      <md-card class="user-admin-card" v-for="(item, index) in users" :key="index">
        <md-card-header></md-card-header>
        <md-card-content>
          <div>
            <div>
              <span class="user-name" @click="updateSystemUser(item)"
                ><strong
                  >{{ item.firstName | firstName }} {{ item.lastName }}</strong
                ></span
              >
              <span
                class="roleIn-type"
                :style="{
                  border: `thin solid ${roleColor[item.roleIn]}`,
                  color: `${roleColor[item.roleIn]}`,
                }"
                >{{ roleLabel[item.roleIn] }}</span
              >

              <md-chips v-model="item.businessNames" md-static v-if="item.business">
                <template slot="md-chip" slot-scope="{ chip }">
                  {{ chip }}
                </template>
              </md-chips>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="nodata-content" v-else>
      <img src="../assets/img/no_data.svg" alt />
      <h5>No hay datos disponibles</h5>
    </div>
    <div class="users__footer"></div>
  </div>
</template>

<script>
import ModalSystemUsers from "@/components/admin/ModalSystemUsers";
import { mapGetters, mapActions } from "vuex";

import VueContentLoading from "vue-content-loading";
import business from "../store/modules/business";
import { service } from "../api/api";

export default {
  components: {
    ModalSystemUsers,
    VueContentLoading,
  },

  created() {
    // this.getEmployees(this.$localStorage.get("businessID")).then(r => {
    //   console.log(r);
    //   this.loading = false;
    // });
    this.$store.dispatch("getSystemUsers").then(async (res) => {
      this.loading = false;
      this.businessListAux = await service.getBusinessAux({ page: 1, limit: 100 });
    });

    // console.log(this.listEmploy)
  },

  data: () => ({
    //loading data
    loading: true,
    showEmployee: null,
    nombres: "jose luis",
    ModalUsersActive: false,
    ModalUsersActiveUpdate: false,
    selectedUser: null,
    roleLabel: {
      owner: "Dueño", //Dueño de la empresa
      // master: 'Maestro',
      // manager: 'Administrador',
      normal: "Empleado", // puede hacer escritura
      guest: "Invitado", // solo lectura
    },
    roleColor: {
      owner: "#0455bf",
      normal: "#4a90ed",
      guest: "#b0cef5",
    },
    actualBusiness: null,
    businessListAux: null,
  }),

  filters: {
    firstName(value) {
      if (!value) return value;
      if (value.search(" ") != -1) return value.slice(0, value.search(" "));
      else return value;
    },
  },

  computed: {
    listUsersSystem() {
      return this.$store.getters.listSystemUsers.map((user) => {
        return {
          ...user,
          businessNames: user.business
            ? user.business.map((business) => business.name)
            : [],
        };
      });
    },
    users() {
      if (!this.actualBusiness) return this.listUsersSystem;
      return this.listUsersSystem.filter((user) =>
        user.business.some((business) => business.id === this.actualBusiness)
      );
    },
    businessList() {
      if (!this.businessListAux) return [];
      return this.businessListAux.data.results;
    },
  },

  methods: {
    ...mapActions({
      getEmployees: "getEmployees",
    }),

    updateSystemUser(user) {
      this.selectedUser = JSON.parse(JSON.stringify(user));
      this.ModalUsersActiveUpdate = true;
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.modal {
  z-index: 500;
}

.users {
  // height: 100%;
  padding: 1rem 0.5rem;
  background-color: #eceff8;
  // overflow: auto;
  // overflow-y: scroll;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // flex-wrap: wrap;
  @include mq("800px") {
    height: auto;
    min-height: 100%;
  }

  &__header {
    width: 24rem;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    background-color: #fff;
    padding: 0.8rem 1.2rem;
    @include mq($sm) {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
    }
    @include mq("800px") {
      width: auto;
      & > * {
        margin: 0.5rem 1.2rem;
      }
    }
    @include mq($md) {
      justify-content: center;
    }
  }
  &__first {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include mq("800px") {
      width: 10rem;
    }
  }
  &__add {
    margin: 0;
    .button-add {
      background-color: $b-emph;
      color: #fff;
      border-radius: 3px;
      padding: 0.5rem 1rem;
    }
  }
  &__search {
    background-color: #fff;
    border-radius: 3px;
    margin-top: 1rem;
    padding-left: 0.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    width: 100%;
    @include mq("800px") {
      width: 24rem;
      margin-top: 0.5rem;
    }
    .icon-search {
      margin-right: 1rem;
    }
  }

  &__body {
    margin-top: 1rem;

    .container {
      width: 24rem;
      height: 8rem;
      background-color: #fff;
      margin-bottom: 1rem;
      border-radius: 0.5rem;
      @include mq("800px") {
        margin: 0.6rem 1.2rem;
      }
      &__body {
        height: 75%;
        border-bottom: 1px solid #d7dae2;
        display: flex;
        justify-content: space-between;
        padding: 1rem 1rem 0 1rem;
      }
      &__img {
        height: 3rem;
        width: 3rem;
        border-radius: 100%;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
      &__datos {
        // margin-left: -0.5rem;
        min-width: 180px;
        &-nombres {
          font-weight: 700;
          @include mq($lg) {
            cursor: pointer;
          }
        }
        &-cargo {
          display: flex;
          justify-content: flex-start;
          color: rgba(#43425d, 0.5);
          // i {
          //   margin-left: 1rem;
          // }
        }
        &-fono {
          display: flex;
          width: 100%;
          justify-content: flex-start;
          color: rgba(#43425d, 0.5);
          // i {
          //   margin-left: 1rem;
          // }
        }
      }
      &__tools {
        color: #a4afb7;
        .icon-edit {
          @include mq($lg) {
            cursor: pointer;
          }
        }
        .icon-close {
          margin-left: 0.5rem;
        }
      }
      &__footer {
        height: 25%;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          color: #cecfd0;
          font-size: 1.5rem;
          margin: 0 1rem;
        }
      }
    }
  }
}

.item-loading {
  width: 24rem;
  height: 8rem;
  background-color: white;
  border-radius: 9px;
  margin-bottom: 1rem;
  @include mq("800px") {
    margin: 0.6rem 1.2rem;
  }
}
.business-name {
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nodata-content {
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  img {
    width: 300px;
    margin: 0 auto;
  }
  h5 {
    color: $b-emph;
    margin: 2rem auto;
    font-size: 24px;
  }
}
.roleIn-type {
  border-radius: 10px;
  padding: 4px 8px;
  margin-left: 1rem;
}
.business-field {
  max-width: 300px;
  margin: 0 1rem;
}
.user-name {
  cursor: pointer;
  color: $b-blue;
  &:hover {
    color: $b-orange;
  }
}
.user-admin-card {
  margin: 0.5em 0;
}
</style>
